import React, {useState, useRef, useEffect} from "react";
import Modal from "../../styles/Modals";
import styled from "styled-components";
import Color from "../../assets/Colors";
import useQuery from "../../hooks/useQuery";
import LegalWarning from "./LegalWarning";
import CookiesWarn from "./CookiesWarn";

export default function TermsView() {
   const [tabNum, setTabNum] = useState(1);
   let query = useQuery();
   const isOpen = query.get("terms") === "true" ? true : false;
   let viewsRef = useRef(null);
   let coockiesRef = useRef(null);
   let legalRef = useRef(null);

   /*   useEffect(() => {
      changeTab(2);
   }, []); */

   const changeTab = (num) => {
      setTabNum(num);
      switch (num) {
         case 1:
            return offsetTo(legalRef);
         case 2:
            return offsetTo(coockiesRef);
         default:
            return false;
      }
   };

   const offsetTo = (ref) => {
      // console.log(viewsRef.current);
      viewsRef.current.scrollTo({top: 0, left: ref.current.offsetLeft, behavior: "smooth"});
   };

   if (!isOpen) return null;

   return (
      <Modal back="rgba(100,100,100,0.6)">
         <>
            <TabsList>
               <TabItem
                  onClick={() => {
                     changeTab(1);
                  }}
                  className={tabNum === 1 ? "isActive" : ""}
               >
                  Aviso Legal
               </TabItem>
               <TabItem
                  onClick={() => {
                     changeTab(2);
                  }}
                  className={tabNum === 2 ? "isActive" : ""}
               >
                  Política de cookies
               </TabItem>
            </TabsList>

            <TabViewContainer ref={viewsRef}>
               <SlideStyle ref={legalRef}>
                  <LegalWarning
                     goToCoockies={() => {
                        changeTab(2);
                     }}
                  />
               </SlideStyle>
               <SlideStyle
                  ref={coockiesRef}
                  goToLegal={() => {
                     changeTab(1);
                  }}
               >
                  <CookiesWarn />
               </SlideStyle>
            </TabViewContainer>
         </>
      </Modal>
   );
}

const TabsList = styled.div`
   width: 100%;
   height: 100%;
`;
const TabItem = styled.button`
   background: transparent;
   outline: none;
   border: none;
   // border: 1px inset ${Color.primary};
   font-size: 1em;
   font-family: Montserrat;
   padding: 0.5em 1em;
   background-color: rgba(120,120,120,0.8);
   transition: all 420ms ease;
   opacity: 0.5;
   color: white;
   
   &.isActive {
      color: ${Color.primary};
      background-color: rgba(120,120,120,0.1);
      opacity: 1;
      border-top-right-radius: 1em;
      transition: all 420ms ease;
   }
`;

const TabViewContainer = styled.div`
   scroll-snap-type: x mandatory;
   -webkit-overflow-scrolling: touch;
   overflow-x: scroll;
   display: flex;

   ::-webkit-scrollbar {
      display: none;
   }
`;

const SlideStyle = styled.div`
   scroll-snap-align: start;
   height: 500px;
   overflow-y: scroll;
   min-width: 100%;
   padding: 0 0.5em;

   ::-webkit-scrollbar {
      display: none;
   }
`;

const TitleStyled = styled.p`
   color: ${Color.primary};
   font-weight: 200;
   font-size: 1.7em;
   margin-top: 3em;

   @media screen and (max-width: 1600px) {
      font-size: 1.4em;
   }
`;

const SubtitleStyled = styled.p`
   color: ${Color.primary};
   font-weight: 500;
   font-size: 1.1em;
   margin-top: 2em;

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }
`;

const TextStyled = styled.p`
   font-size: 1em;
   color: grey;
   margin-top: 0.5em;
   font-weight: 300;
   text-align: justify;

   & a {
      color: inherit;
      text-decoration: underline;
   }

   @media screen and (max-width: 1600px) {
      font-size: 0.8em;
   }
`;
